import { render, staticRenderFns } from "./StructuredList.vue?vue&type=template&id=30019818&scoped=true&"
import script from "./StructuredList.vue?vue&type=script&lang=js&"
export * from "./StructuredList.vue?vue&type=script&lang=js&"
import style0 from "./StructuredList.vue?vue&type=style&index=0&id=30019818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30019818",
  null
  
)

export default component.exports